import { Check, X } from "@phosphor-icons/react";

export const PASSWORD_RULES = [
  { id: "len", label: "At least 8 characters", test: (p) => (p || "").length >= 8 },
  { id: "lower", label: "One lowercase letter", test: (p) => /[a-z]/.test(p || "") },
  { id: "upper", label: "One uppercase letter", test: (p) => /[A-Z]/.test(p || "") },
  { id: "symbol", label: "One symbol (e.g. ! @ # $)", test: (p) => /[^A-Za-z0-9]/.test(p || "") },
];

export function passwordIsStrong(password) {
  return PASSWORD_RULES.every((r) => r.test(password));
}

// Inline live-validation list. Renders a check or × for each rule.
export default function PasswordRequirements({ password = "", testid = "password-requirements" }) {
  return (
    <ul
      className="mt-2 space-y-1"
      data-testid={testid}
    >
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.id}
            className={`flex items-center gap-2 text-[11px] ${
              ok ? "text-emerald-600 dark:text-mint" : "text-slate-500"
            }`}
            data-testid={`pwreq-${rule.id}-${ok ? "ok" : "fail"}`}
          >
            <span
              className={`h-3.5 w-3.5 rounded-full flex items-center justify-center ${
                ok
                  ? "bg-emerald-100 text-emerald-700 dark:bg-mint/20 dark:text-mint"
                  : "bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500"
              }`}
            >
              {ok ? <Check size={9} weight="bold" /> : <X size={9} weight="bold" />}
            </span>
            <span>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
